import ApiClient from "@/api/ApiClient";

class SupportService {
  #prefixUrl = 'api/support/';

  constructor() {
    this.api = new ApiClient(this.#prefixUrl);
  }

  async informSupportError(data = {}) {
    data.master_pass = process.env.VUE_APP_MASTER_PASS;
    const response = await this.api.executeRequest('/error', data, this.api.methods.POST, {}, true);
    return response;
  }
}

export default new SupportService();
